/**
 * @author slak4170
 * */
import {
  RESET_COST_VIEW_SEARCH_FILTER,
  UPDATE_COST_VIEW_SEARCH_FILTER,
} from '../actions/costViewActions';
import initialState from './initialState';

export default function costViewSearchFilterReducer(state, { type, data }) {
  if (state === undefined) {
    return initialState.costViewSearchFilter;
  }

  if (type === UPDATE_COST_VIEW_SEARCH_FILTER) {
    return { ...data };
  }

  if (type === RESET_COST_VIEW_SEARCH_FILTER) {
    return {
      ...initialState.costViewSearchFilter,
    };
  }

  return state;
}
